<template>
  <div class="CheckButtonList">
    <ul class="list">
      <li class="item" v-for="item in items" :key="item.key">
        <UiCheck
          isButton
          :value="value.includes(item.key)"
          @input="isActive => toggleValue(item.key, isActive)"
        >{{item.label}}</UiCheck>
      </li>
    </ul>
  </div>
</template>

<script>
import UiCheck from '@/components/atoms/UiCheck'

export default {
  name: 'CheckButtonList',
  components: {
    UiCheck,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    toggleValue(key, isActive) {
      if (isActive) {
        this.$emit('input', [...this.value, key])
      } else {
        this.$emit('input', this.value.filter(curKey => curKey !== key))
      }
    },
  }
}
</script>

<style scoped lang="scss">
$gutter: 2px;

.list {
  display: flex;
  flex-wrap: wrap;
  margin: -1 * $gutter;
}

.item {
  box-sizing: border-box;
  width: 50%;
  padding: $gutter;
}
</style>
